<template lang="pug">
  b-card
    b-card.no-shadow.bg-light(no-body)
      b-row.align-items-center.py-2.px-3
        b-col
          b-input-group(v-if="edit_name_enabled", size="sm" )
            b-form-input.bg-white(autocomplete="off", placeholder="Nombre", v-model="block_name")
            b-input-group-append
              b-button(variant="soft-primary", @click="emitUpdate")
                .d-flex.align-items-center
                  span.mr-1.d-none.d-md-inline-block.text-sm Guardar
                  save-icon.icon-sm
          .d-flex.align-items-center(v-else)
            h5.mb-0.d-inline-block {{ block_name || 'Bloque sin nombre' }}
            edit3-icon.icon-md.hover-primary.pointer.text-secondary.ml-2(@click="edit_name_enabled = true")
          p.mb-0.text-secondary(v-if="!block_name") Agrega un nombre a este bloque para que lo puedas buscar más fácilmente
        b-col(cols="auto")
          b-form-checkbox(switch, :checked="enable", @change="$emit('block:update', {enable: $event})") {{enable ? 'Activado' : 'Desactivado'}}
        b-col(cols="auto")
          trash-2-icon.icon-md.hover-danger.pointer.text-secondary(v-if="$can('delete', 'faq-block')", @click="$emit('block:destroy')")

    //- QUESTIONS
    .d-flex.align-items-center.mb-1
      b-link.text-reset(v-b-toggle="'questions_' + _id")
        h5.mb-0 Variantes de pregunta
          chevron-down-icon.ml-1.icon-md
    b-collapse(:id="'questions_' + _id")
      p.text-secondary Entrena las distintas formas tus clientes preguntan sobre un mismo tema 
      b-form-row
        b-col(:md="secondLanguage ? 6 : null")
          p.mb-3.text-secondary(v-if="secondLanguage") {{ defaultLanguageName }} ({{ defaultLocale }})
          .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
            b-spinner.mr-3(small, variant="primary", v-if="loading_questions")
            b-button.mr-2.my-1(variant="primary", size="sm", @click="createQuestion({value: ''})")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar pregunta
            b-button.mr-2.my-1(variant="soft-primary", size="sm", @click="questions_input_modal = true")
              .d-flex.align-items-center
                upload-icon.icon-sm.mr-1
                span.mr-1 Agregar varias
            b-button.my-1(variant="soft-primary", size="sm", @click="downloadQuestions", v-if="$can('read', 'advanced-training')")
              .d-flex.align-items-center
                download-icon.icon-sm.mr-1
                span.mr-1 Descargar preguntas
          p.text-help.my-4.text-center(v-if="!qb_questions.length && !loading") No hay preguntas
          b-input-group.mb-2(v-for="(question, index) in qb_questions", :key="index", size="sm",)
            b-form-input(autocomplete="off", placeholder="Escribe la pregunta", v-model="question.value", :class="{'text-primary font-weight-bold' : search_text.length && question.value.search(search_regex) >= 0}", @input="updateQuestion(index, question)")
            b-input-group-append
              b-button(:variant="question.loading ? 'soft-secondary' : 'soft-danger'", @click="destroyQuestion(index, question)", :disabled="question.loading")
                b-spinner(small, variant="primary", v-if="question.loading")
                trash-2-icon.icon-sm(v-else)

          .d-flex.align-items-center.mb-4
            b-pagination.mb-0(size="sm", :total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getQuestions')", v-if="v_paginationShow")
            b-spinner.ml-3(small, variant="primary", v-if="loading")

          div(v-if="unanswered.length")
            .d-flex.align-items-center.mb-3
              h5.text-secondary.mb-0.d-inline-block Preguntas sugeridas por el Bot:
              b-spinner.ml-2(small, variant="primary", v-if="destroy_all_loading")
            div(v-if="!destroy_all_loading")
              b-input-group.mb-2(v-for="(question, index) in unanswered", :key="'unanswered_' + index")
                b-form-input.bg-white(autocomplete="off", placeholder="Pregunta sugerida", :value="question.text", readonly, size="sm" )
                b-input-group-append(v-if="question.loading")
                  b-input-group-text
                    b-spinner(small, variant="primary")
                template(v-else)
                  b-input-group-append
                    b-button(variant="soft-danger", @click="destroyUnanswered(index, question)")
                      x-icon.icon-sm
                  b-input-group-append
                    b-button(variant="soft-success", @click="createUnanswered(index, question)")
                      check-icon.icon-sm
              .d-flex.align-items-center.justify-content-end
                b-link.text-danger(@click="destroyAllUnanswered") Descartar {{ unanswered.length }} sugeridas

        //- SECOND LANGUAGE QUESTIONS
        //-

        b-col(md="6", v-if="secondLanguage")
          p.mb-3.text-secondary {{ selectedLanguageName }} ({{ selectedLocale }})
          .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
            b-spinner.mr-3(small, variant="primary", v-if="loading_second_questions")
            b-button.mr-2.my-1(variant="soft-success", size="sm", @click="createQuestion({value: '', language_id: selectedLanguage})")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar pregunta
            b-button.mr-2.my-1(variant="soft-primary", size="sm", @click="isForSecondLanguage = true;questions_input_modal = true")
              .d-flex.align-items-center
                upload-icon.icon-sm.mr-1
                span.mr-1 Agregar varias
            b-button.my-1(variant="soft-primary", size="sm", @click="downloadQuestions({language_id: selectedLanguage})", v-if="$can('read', 'advanced-training')")
              .d-flex.align-items-center
                download-icon.icon-sm.mr-1
                span.mr-1 Descargar preguntas
          p.text-help.my-4.text-center(v-if="!second_qb_questions.length && !loading_second_questions") No hay preguntas
          b-input-group.mb-2(v-for="(question, index) in second_qb_questions", :key="index", size="sm",)
            b-form-input(autocomplete="off", placeholder="Escribe la pregunta", v-model="question.value", :class="{'text-primary font-weight-bold' : search_text.length && question.value.search(search_regex) >= 0}", @input="updateQuestion(index, question)")
            b-input-group-append
              b-button(:variant="question.loading ? 'soft-secondary' : 'soft-danger'", @click="destroyQuestion(index, question, selectedLanguage)", :disabled="question.loading")
                b-spinner(small, variant="primary", v-if="question.loading")
                trash-2-icon.icon-sm(v-else)

          .d-flex.align-items-center.mb-4
            b-pagination.mb-0(size="sm", :total-rows="secondPaginationParamsObject.totalRows", :per-page="secondPaginationParamsObject.limit", :value="secondPaginationCurrentPage", v-if="secondPaginationParamsObject.show", @change="getSecondQuestions")

    //- RESPUESTAS
    //- ANSWERS

    .d-flex.align-items-center.mb-1
      b-link.text-reset(v-b-toggle="'answers_' + _id")
        h5.mb-0 Respuesta
          chevron-down-icon.ml-1.icon-md
    b-collapse(:id="'answers_' + _id")
      p.mb-0.text-secondary Entrena cómo debe contestar a las preguntas sobre este tema
      p.mb-0.text-sm.text-secondary Si se agrega más de una respuesta, solo contesta con una al azar
      b-form-row
        b-col(:md="secondLanguage ? 6 : null")
          p.mb-3.text-secondary(v-if="secondLanguage") {{ defaultLanguageName }} ({{ defaultLocale }})
          .d-flex.justify-content-md-end.align-items-center.mb-1.flex-wrap
            b-spinner.mr-3(small, variant="primary", v-if="loading_answers")
            b-button.mr-2.my-1(variant="soft-success", size="sm", @click="createAnswer")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar respuesta
            b-button.my-1(variant="soft-primary", size="sm", @click="answers_input_modal = true")
              .d-flex.align-items-center
                upload-icon.icon-sm.mr-1
                span.mr-1 Agregar varias
          p.text-help.my-4.text-center(v-if="!qb_answers.length && !loading_answers") No hay respuestas
          div.mb-3(v-for="(answer, index) in qb_answers", :key="index")
            b-input-group.mb-2(size="sm")
              b-form-textarea(autocomplete="off", placeholder="Escribe la respuesta", v-model="answer.value", :class="{'text-primary font-weight-bold' : search_text.length && answer.value.search(search_regex) >= 0}", @input="updateAnswer(index, answer)")
              b-input-group-append
                b-button(:variant="answer.loading ? 'soft-secondary' : 'soft-danger'", @click="destroyAnswer(index, answer)", :disabled="answer.loading")
                  b-spinner(small, variant="primary", v-if="answer.loading")
                  trash-2-icon.icon-sm(v-else)
            input(type="file", accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv", style="display:none;", :ref="'answer_input_' + index", @change="fileSelected($event, index)", v-if="inputCreated")
            div.px-3.d-flex.align-items-center
              corner-down-right-icon.icon-sm.mr-3
              b-link.text-sm(@click="$refs['answer_input_' + index][0].click()") Adjuntar archivo o imagen
            div.mt-2.d-flex.flex-wrap(style="padding-left:48px;")
              b-card.mb-1.mr-1.px-1.py-2.bg-light(no-body, v-for="(media, media_index) in answer.media", :key="media_index")
                .d-flex.align-items-center.my-auto
                  b-img.mr-2(v-if="media.type === 'image'", width="30", height="30", :src="media.url")
                  span.mr-2.text-secondary.text-sm {{ getFileExt(media.url) }}
                  x-icon.icon-sm.text-danger.pointer(@click="removeMedia(media_index, index)")


        //- SECOND ANSWERS
        //-

        b-col(md="6", v-if="secondLanguage")
          p.mb-3.text-secondary {{ selectedLanguageName }} ({{ selectedLocale }})
          .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
            b-spinner.mr-3(small, variant="primary", v-if="loading_second_answers")
            b-button.mr-2.my-1(variant="soft-success", size="sm", @click="createAnswer({language_id: selectedLanguage})")
              .d-flex.align-items-center
                plus-icon.icon-sm.mr-1
                span.mr-1 Agregar respuesta
            b-button.my-1(variant="soft-primary", size="sm", @click="isForSecondLanguage = true;answers_input_modal = true")
              .d-flex.align-items-center
                upload-icon.icon-sm.mr-1
                  span.mr-1 Agregar varias

          p.text-help.my-4.text-center(v-if="!second_qb_answers.length && !loading_second_answers") No hay respuestas
          b-input-group.mb-2(v-for="(answer, index) in second_qb_answers", :key="index")
            b-form-input(autocomplete="off", placeholder="Escribe la respuesta", v-model="answer.value", :class="{'text-primary font-weight-bold' : search_text.length && answer.value.search(search_regex) >= 0}", @input="updateAnswer(index, answer)")
            b-input-group-append
              b-button(:variant="answer.loading ? 'soft-secondary' : 'soft-danger'", @click="destroyAnswer(index, answer, selectedLanguage)", :disabled="answer.loading")
                b-spinner(small, variant="primary", v-if="answer.loading")
                trash-2-icon.icon-sm(v-else)

    //- ACCIONES
    //- ACTIONS
    div(v-if="$can('update', 'faq-block-connection')")
      .d-flex.align-items-center.mb-1
        b-link.text-reset(v-b-toggle="'actions_' + _id")
          h5.mb-0 Conexiones
            chevron-down-icon.ml-1.icon-md
      b-collapse(:id="'actions_' + _id")
        p.text-secondary Además de contestar con texto, puedes enviar el Chatbot a una parte del flujo creando una conexión
        .d-flex.justify-content-md-end.align-items-center.mb-2.flex-wrap
          b-button.mr-2.my-1(variant="soft-success", size="sm", @click="$emit('action:create')", :disabled="action != null")
            .d-flex.align-items-center
              plus-icon.icon-sm.mr-1
              span Agregar conexión
        p.text-help.my-4.text-center(v-if="!action") No hay ninguna conexión
        .mb-2(v-if="action")
          block-connector(v-bind="action.payload", @change="$emit('action:update', {type: action.type, action_id: action.id, payload: $event})")
          b-link.text-danger(@click="$emit('action:destroy', {type: action.type, action_id: action.id})") Borrar accion

    //- LISTS
    //- LISTAS
    div(v-if="$can('read', 'training-lists')")
      .d-flex.align-items-center
        b-link.text-reset(v-b-toggle="'lists_' + _id")
          h5.mb-0 Listas
            chevron-down-icon.ml-1.icon-md
      b-collapse(:id="'lists_' + _id")
        p.text-secondary Las listas te permite contestar este entrenamiento solo en ciertas plataformas
        treeselect.mb-2(:options="parsedLists", placeholder="- Seleccionar listas -", v-model="qb_lists", v-bind="treeselect_options", :multiple="true", :clearable="false")
    // FILTERS
    .d-flex.align-items-center
      b-link.text-reset(v-b-toggle="'filters_' + _id")
        h5.mb-0 Filtros
          chevron-down-icon.ml-1.icon-md
    b-collapse(:id="'filters_' + _id")
      p.text-secondary Las listas te permite contestar este entrenamiento solo en ciertas plataformas
      treeselect.mb-2(:options="filters", placeholder="- Seleccionar filtros -", v-model="qb_filters", v-bind="treeselect_options", :multiple="true", :clearable="false", @select="addFilter", @deselect="removeFilter")
    b-modal(:title="`Preguntas de bloque ${_id}`", v-model="questions_modal", ok-only, ok-title="Cerrar", ok-variant="secondary")
      b-form-textarea(placeholder="No hay preguntas", rows="10", max-rows="10", readonly, :value="questions_lines", no-resize)
    b-modal(:title="`Ingresar preguntas para bloque ${_id}`", v-model="questions_input_modal", ok-title="Cargar preguntas", ok-variant="primary", cancel-title="Cancelar", cancel-variant="secondary", @ok="createQuestionsFromInput")
      h4.mb-0.text-secondary(v-if="isForSecondLanguage") {{ selectedLanguageName }} {{ selectedLocale }}
      p Da un salto de línea por cada pregunta
      b-form-textarea(placeholder="Ingresa la lista de preguntas", rows="10", max-rows="10", v-model="questions_input", no-resize)
    b-modal(:title="`Ingresar respuestas para bloque ${_id}`", v-model="answers_input_modal", ok-title="Cargar respuestas", ok-variant="primary", cancel-title="Cancelar", cancel-variant="secondary", @ok="createAnswersFromInput")
      h4.mb-0.text-secondary(v-if="isForSecondLanguage") {{ selectedLanguageName }} {{ selectedLocale }}
      p Da un salto de línea por cada respuesta
      b-form-textarea(placeholder="Ingresa la lista de respuestas", rows="10", max-rows="10", v-model="answers_input", no-resize)
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const listController = createNamespacedHelpers('list')
const accountController = createNamespacedHelpers('account')
const propertyFilterController = createNamespacedHelpers('property_filter')

import treeselectOptions from '@/data/treeselect-options'
import _debounce from 'lodash.debounce'

import { UploadFile } from '@/helpers/upload-file'

export default {
  data () {
    return {
      qb_questions: [],
      qb_answers: [],
      qb_keywords: [],
      qb_lists: [],
      qb_filters: [],
      loading: false,
      loading_questions: false,
      loading_answers: false,
      loading_keywords: false,
      new_keyword: {
        loading: false,
        value: '',
        show: false
      },
      new_second_keyword: {
        loading: false,
        value: '',
        show: false
      },
      treeselect_options: treeselectOptions,
      qb_lists_loaded: false,
      questions_modal: false,
      questions_lines: '',
      unanswered: [],
      destroy_all_loading: false,
      questions_input: '',
      questions_input_modal: false,
      isForSecondLanguage: false,
      secondPaginationParamsObject: {
        page: 1,
        limit: 7,
        hasNextPage: false,
        totalRows: false,
        show: false
      },
      second_qb_questions: [],
      second_qb_answers: [],
      second_qb_keywords: [],
      loading_second_questions: false,
      loading_second_answers: false,
      loading_second_keywords: false,
      answers_input: '',
      answers_input_modal: false,
      inputCreated: true,
      block_name: '',
      edit_name_enabled: false,
    }
  },
  props: {
    _id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    enable: {
      type: Boolean,
      default: true
    },
    action: {
      type: Object,
      default: function () {
        return null
      }
    },
    Lists: {
      type: Array,
      default: function () {
        return []
      }
    },
    Filters: {
      type: Array,
      default: function () {
        return []
      }
    },
    Unanswered: {
      type: Array,
      default: function () {
        return []
      }
    },
    History: {
      type: Array,
      default: function () {
        return []
      }
    },
    questions: {
      type: Array,
      default: function () {
        return []
      }
    },
    answers: {
      type: Array,
      default: function () {
        return []
      }
    },
    keywords: {
      type: Array,
      default: function () {
        return []
      }
    },
    questionsHasNextPage: {
      type: Boolean,
      default: false
    },
    questionsPages: {
      type: Number,
      default: 1
    },
    search_text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...listController.mapState({
      lists: state => state.lists
    }),
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'defaultLanguageName', 'defaultLocale', 'selectedLanguageName']),
    ...propertyFilterController.mapState({
      filters: state => state.filters.map(el => {
        return {
          id: el._id,
          label: el.title
        }
      })
    }),
    parsedLists () {
      return this.lists.filter(l => Boolean(l.name)).map(l => {
        return {
          id: l._id,
          label: l.name
        }
      })
    },
    secondPaginationCurrentPage () {
      if (this.secondPaginationParamsObject.hasNextPage) {
        return this.secondPaginationParamsObject.page - 1 || 1
      } else {
        return this.secondPaginationParamsObject.page
      }
    },
    secondLanguage () {
      return this.selectedLanguage != 1
    },
    search_regex () {
      return new RegExp(this.search_text, 'gmi')
    }
  },
  methods: {
    ...mapActions(['question/questions', 'question/createQuestion', 'question/updateQuestion', 'question/destroyQuestion',
      'question/keywords', 'question/createKeyword', 'question/updateKeyword', 'question/destroyKeyword',
      'question/answers', 'question/createAnswer', 'question/updateAnswer', 'question/destroyAnswer',
      'list/addBlock', 'list/removeBlock', 'question/destroyUnanswered', 'question/unanswered', 'helpers/upload_file',
      'question/addFilter', 'question/removeFilter']),
    emitUpdate () {
      //console.log('value', this.block_name)
      this.edit_name_enabled = false
      this.$emit('block:update', {name: this.block_name})
    },
    getQuestions () {
      let self = this
      this.loading = true

      this['question/questions']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          ...self.paginationParamsObject,
          text: self.search_text || null
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            
            self.parsePaginationDataFromResponse(res)
            self.qb_questions = res.resource.map(q => {
              q.loading = false
              return q
            })
          }
        }
      })
    },
    getSecondQuestions (event) {
      if (event && !isNaN(event)) {
        this.resetSecondPaginationParamsData()
        this.secondPaginationParamsObject.page = event
      }

      let self = this
      this.loading_second_questions = true
      this.secondPaginationParamsObject.show = false

      this['question/questions']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          ...self.secondPaginationParamsObject,
          language_id: self.selectedLanguage,
        },
        callback: res => {
          self.loading_second_questions = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.secondPaginationParamsObject.totalRows = (res.pages || 1) * self.secondPaginationParamsObject.limit
            self.secondPaginationParamsObject.hasNextPage = res.hasNextPage || false
            if (self.secondPaginationParamsObject.hasNextPage) self.secondPaginationParamsObject.page ++
            self.secondPaginationParamsObject.show = true

            self.second_qb_questions = res.resource.map(q => {
              q.loading = false
              return q
            })
          }
        }
      })
    },
    createQuestion (question) {
      let self = this

      if (question.language_id) {
        this.loading_second_questions = true
      } else {
        this.loading_questions = true
      }

      this['question/createQuestion']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        value: question.value,
        language_id: question.language_id || 1,
        callback: res => {
          self.loading_questions = false
          self.loading_second_questions = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (question.language_id) {
              self.second_qb_questions.splice(0, 0, res.resource)
            } else {
              self.qb_questions.splice(0, 0, res.resource)
              if (question.callback) {
                question.callback()
              }
            }
          }
        }
      })
    },
    _updateQuestion (index, question) {
      let self = this
      question.loading = true

      this['question/updateQuestion']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        question_id: question._id,
        ...question,
        callback: res => {
          question.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            // self.qb_questions.splice(index, 1, res.resource)
            // do nothing on success
          }
        }
      })
    },
    destroyQuestion (index, question, language_id) {
      let self = this
      question.loading = true

      this['question/destroyQuestion']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        question_id: question._id,
        ...question,
        callback: res => {
          question.loading = false
          console.log("HERE")
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log("aQU", language_id)
            if (language_id) {
              self.second_qb_questions.splice(index, 1)
            } else {
              self.qb_questions.splice(index, 1)
            }
          }
        }
      })
    },
    getAnswers () {
      let self = this
      this.loading = true

      this['question/answers']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.qb_answers = res.resource.map(a => {
              a.loading = false
              return a
            })
          }
        }
      })
    },
    getSecondAnswers () {
      let self = this
      this.loading_second_answers = true

      this['question/answers']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          language_id: self.selectedLanguage,
        },
        callback: res => {
          self.loading_second_answers = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.second_qb_answers = res.resource.map(a => {
              a.loading = false
              return a
            })
          }
        }
      })
    },
    createAnswer (answer) {
      let self = this

      if (answer.language_id) {
        this.loading_second_answers = true
      } else {
        this.loading_answers = true
      }

      this['question/createAnswer']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        language_id: answer.language_id || 1,
        callback: res => {
          self.loading_answers = false
          self.loading_second_answers = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (answer.language_id) {
              self.second_qb_answers.splice(0, 0, res.resource)
            } else {
              self.qb_answers.splice(0, 0, res.resource)
            }
          }
        }
      })
    },
    _updateAnswer (index, answer) {
      let self = this
      answer.loading = true

      this['question/updateAnswer']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        answer_id: answer._id,
        ...answer,
        callback: res => {
          answer.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            // do nothing on success
          }
        }
      })
    },
    destroyAnswer (index, answer, language_id) {
      let self = this
      answer.loading = true

      this['question/destroyAnswer']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        answer_id: answer._id,
        ...answer,
        callback: res => {
          answer.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (language_id) {
              self.second_qb_answers.splice(index, 1)
            } else {
              self.qb_answers.splice(index, 1)
            }
          }
        }
      })
    },
    getKeywords () {
      let self = this
      this.loading = true

      this['question/keywords']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.qb_keywords = res.resource.map(k => {
              k.loading = false
              return k
            })
          }
        }
      })
    },
    getSecondKeywords () {
      let self = this
      this.loading_second_keywords = true

      this['question/keywords']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          language_id: self.selectedLanguage,
        },
        callback: res => {
          self.loading_second_keywords = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.second_qb_keywords = res.resource.map(k => {
              k.loading = false
              return k
            })
          }
        }
      })
    },
    createKeyword (keyword) {
      let self = this
      let kw

      if (keyword.language_id) {
        this.new_second_keyword.loading = true
        kw = this.new_second_keyword
      } else {
        this.new_keyword.loading = true
        kw = this.new_keyword
      }

      this['question/createKeyword']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        language_id: keyword.language_id,
        ...kw,
        callback: res => {
          self.new_keyword.loading = false
          self.new_second_keyword.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (keyword.language_id) {
              this.clearObject(this.new_second_keyword)
              self.second_qb_keywords.splice(0, 0, res.resource)
            } else {
              this.clearObject(this.new_keyword)
              self.qb_keywords.splice(0, 0, res.resource)
            }
          }
        }
      })
    },
    _updateKeyword (index, keyword) {
      let self = this
      keyword.loading = true

      this['question/updateKeyword']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        keyword_id: keyword.id,
        ...keyword,
        callback: res => {
          keyword.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            // do nothing on success
          }
        }
      })
    },
    destroyKeyword (index, keyword) {
      let self = this
      keyword.loading = true

      this['question/destroyKeyword']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        keyword_id: keyword.id,
        ...keyword,
        callback: res => {
          keyword.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.qb_keywords.splice(index, 1)
          }
        }
      })
    },
    addBlockToList (id) {
      let self = this

      this['list/addBlock']({
        account_id: self.$route.params.account_id,
        block_id: self._id,
        list_id: id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
            let index = self.qb_lists.findIndex(l => l._id == id)
            self.qb_lists.splice(index, 1)
          } else {
            self.$message.success('Lista agregada')
          }
        }
      })
    },
    removeBlockFromList (id) {
      let self = this

      this['list/removeBlock']({
        account_id: self.$route.params.account_id,
        block_id: self._id,
        list_id: id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
            self.qb_lists.push(id)
          } else {
            self.$message.success('Lista quitada')
          }
        }
      })
    },
    downloadQuestions (event) {
      let self = this
      this.showLoadingScreen()

      this['question/questions']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          page: 1,
          limit: 1000,
          language_id: event.language_id || 1
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let lines = ''

            for (let q of res.resource) {
              lines += (q.value + '\n')
            }

            self.questions_lines = lines
            self.questions_modal = true
          }
        }
      })
    },
    getUnanswered () {
      let self = this

      this['question/unanswered']({
        account_id: self.$route.params.account_id,
        question_block_id: self._id,
        params: {
          page: 1,
          limit: 5
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.unanswered = res.resource.map(h => {
              h.loading = false
              return h
            })
          }
        }
      })
    },
    createUnanswered (index, question) {
      let self = this
      question.loading = true

      this.createQuestion({
        value: question.text,
        callback: () => {
          question.loading = false
          self.destroyUnanswered(index, question)
        }
      })
    },
    destroyUnanswered (index, question) {
      let self = this
      question.loading = true

      this['question/destroyUnanswered']({
        account_id: self.$route.params.account_id,
        unanswered_id: question.id,
        callback: res => {
          question.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.unanswered.splice(index, 1)
            if (self.unanswered.length <= 3) {
              self.getUnanswered()
            }
          }
        }
      })
    },
    destroyUnansweredPromise (question) {
      let self = this

      return new Promise((resolve, reject) => {
        this['question/destroyUnanswered']({
          account_id: self.$route.params.account_id,
          unanswered_id: question.id,
          callback: res => {
            resolve()
          }
        })
      })
    },
    async destroyAllUnanswered () {
      this.destroy_all_loading = true
      for (let u of this.unanswered) {
        await this.destroyUnansweredPromise(u)
      }

      this.destroy_all_loading = false
      this.getUnanswered()
    },
    async createQuestionsFromInput (modal) {
      modal.preventDefault()
      // save variable before reset
      let isForSecondLanguage = this.isForSecondLanguage
      this.questions_input_modal = false


      if (!this.questions_input.length) return
      this.showLoadingScreen()

      let questions = []
      for (let line of this.questions_input.split(/\r?\n|\r/g)) {
        questions.push(this.createQuestionPromise(line, isForSecondLanguage ? this.selectedLanguage : null))
      }

      let successCount = 0
      let errorCount = 0
      let message = ''

      try {
        let result = await Promise.all(questions)
        successCount = result.length
        errorCount = questions.length - successCount
      } catch (e) {}

      this.hideLoadingScreen()

      if (errorCount) {
        message = `${successCount} preguntas se crearon correctamente. No se crearon ${errorCount} por un error desconocido.`
      } else {
        message = `${successCount} preguntas se crearon correctamente.`
      }

      this.$bvModal.msgBoxOk(message, {
        okVariant: 'light',
        okTitle: 'Cerrar',
        centered: true
      })
      .then(value => {
        if (isForSecondLanguage) {
          this.resetSecondPaginationParamsData()
          this.getSecondQuestions()
        } else {
          this.resetPaginationData()
          this.getQuestions()
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    async createAnswersFromInput (modal) {
      modal.preventDefault()
      // save variable before reset
      let isForSecondLanguage = this.isForSecondLanguage
      this.answers_input_modal = false


      if (!this.answers_input.length) return
      this.showLoadingScreen()

      let answers = []
      for (let line of this.answers_input.split(/\r?\n|\r/g)) {
        answers.push(this.createAnswerPromise(line, isForSecondLanguage ? this.selectedLanguage : null))
      }

      let successCount = 0
      let errorCount = 0
      let message = ''

      try {
        let result = await Promise.all(answers)
        successCount = result.length
        errorCount = answers.length - successCount
      } catch (e) {}

      this.hideLoadingScreen()

      if (errorCount) {
        message = `${successCount} respuestas se crearon correctamente. No se crearon ${errorCount} por un error desconocido.`
      } else {
        message = `${successCount} respuestas se crearon correctamente.`
      }

      this.$bvModal.msgBoxOk(message, {
        okVariant: 'light',
        okTitle: 'Cerrar',
        centered: true
      })
      .then(value => {
        if (isForSecondLanguage) {
          this.getSecondAnswers()
        } else {
          this.getAnswers()
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    createQuestionPromise (value, language_id) {
      let self = this

      return new Promise((resolve, reject) => {
        this['question/createQuestion']({
          account_id: self.$route.params.account_id,
          question_block_id: self._id,
          value: value,
          language_id: language_id || 1,
          callback: res => {
            if (res.error) {
              reject()
            } else {
              resolve()
            }
          }
        })
      })
    },
    createAnswerPromise (value, language_id) {
      let self = this

      return new Promise((resolve, reject) => {
        this['question/createAnswer']({
          account_id: self.$route.params.account_id,
          question_block_id: self._id,
          value: value,
          language_id: language_id || 1,
          callback: res => {
            if (res.error) {
              reject()
            } else {
              resolve()
            }
          }
        })
      })
    },
    resetSecondPaginationParamsData () {
      this.secondPaginationParamsObject.page = 1
      this.secondPaginationParamsObject.hasNextPage = false
    },
    async fileSelected (event, index) {
      let files = event.target.files
      let file = files[0]

      let answer = this.qb_answers[index]
      answer.loading = true

      if(file) {
        if(file.size / 1000000 >= 25) {
          this.$message.warning('El archivo no debe exceder los 25 megabytes')
        } else {
          let type = file.type.match(/image/gmi) ? 'image' : 'file'
          let url = ''
          try {
            url = await UploadFile.call(this, file)
            answer.media.push({
              type: type,
              url: url
            })

            this.updateAnswer(index, answer)
          } catch (e) {
            this.$message.warning('No logramos subir la imagen, por favor comprueba tu conexión a internet')
          }
        }

        answer.loading = false
        this.clearInputFile()
      }
    },
    clearInputFile () {
      this.inputCreated = false
      this.$nextTick(() => {
        this.inputCreated = true
      })
    },
    getFileExt (url) {
      try {
        return url.split('/').slice(-1)[0]
      } catch (e) {
        return url
      }
    },
    removeMedia (media_index, answer_index) {
      let answer = this.qb_answers[answer_index]
      answer.media.splice(media_index, 1)

      this.updateAnswer(answer_index, answer)
    },
    async addFilter() {
      await this.$nextTick()
      this['question/addFilter']({
        account_id: this.$route.params.account_id,
        _id: this._id,
        filters: this.qb_filters,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Filtro agregado')
        }
      })
    },
    removeFilter(event) {
      this['question/removeFilter']({
        account_id: this.$route.params.account_id,
        _id: this._id,
        filter_id: event.id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Filtro eliminado')
        }
      })
    },
  },
  mounted () {
    this.setPaginationLimit(7)

    this.getQuestions()
    if (this.secondLanguage) {
      this.getSecondQuestions()
      this.getSecondAnswers()
      this.getSecondKeywords()
    }

    this.block_name = this.name

    this.qb_answers = this.answers.map(a => {
      a.loading = false
      return a
    })

    /*
    this.qb_keywords = this.keywords.map(k => {
      k.loading = false
      return k
    })

    */

    this.qb_lists = this.Lists.map(l => l._id)
    this.qb_filters = this.Filters.map(f => f._id)

    this.unanswered = this.Unanswered.map(h => {
      h.loading = false
      return h
    })

    this.updateQuestion = _debounce(this._updateQuestion, 300, {leading: false, trailing: true})
    this.updateAnswer = _debounce(this._updateAnswer, 300, {leading: false, trailing: true})
    this.updateKeyword = _debounce(this._updateKeyword, 300, {leading: false, trailing: true})
  },
  watch: {
    qb_lists (newValue, oldValue) {
      // ignore changes the first time
      if (!this.qb_lists_loaded) {
        this.qb_lists_loaded = true
        return
      }

      if (newValue.length > oldValue.length) {
        let changed = newValue.diff(oldValue)
        if (changed.length)
          this.addBlockToList(changed[0])
      } else {
        let changed = oldValue.diff(newValue)
        if (changed.length)
          this.removeBlockFromList(changed[0])
      }
    },
    questions_input_modal (value) {
      if (value == false) {
        this.questions_input = ''
        this.isForSecondLanguage = false
      }
    },
    answers_input_modal (value) {
      if (value == false) {
        this.answers_input = ''
        this.isForSecondLanguage = false
      }
    }
  },
  languageChanged (language_id) {
    this.resetSecondPaginationParamsData()
    this.second_qb_questions = []
    this.second_qb_answers = []
    this.second_qb_keywords = []

    if (this.secondLanguage) {
      this.getSecondQuestions()
      this.getSecondAnswers()
      this.getSecondKeywords()
    }
  },
}
</script>

<style lang="scss" scoped>

  @media (max-width: 425px) {
    .hide-on-mobile {
      display:  none;
    }
  }
</style>
